<template>
  <d-container fluid class="main-content-container px-0">
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('agents.settlements.date') }}</th>
            <th scope="col" class="border-0">{{ $t('agents.settlements.quote') }}</th>
            <th scope="col" class="border-0">{{ $t('agents.settlements.currency') }}</th>
            <th scope="col" class="border-0">{{ $t('agents.settlements.ordersList') }}</th>
            <th scope="col" class="border-0">{{ $t('agents.settlements.invoicesList') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="allDataLoaded">
          <tr
            v-for="(settlement, index) of settlements"
            :key="'settlement-' + index">
            <td class="align-middle">
              {{ settlement.created_at }}
            </td>
            <td class="align-middle">
              {{ settlement.amount }}
            </td>
            <td class="align-middle">
              {{ settlement.currency_code }}
            </td>
            <td class="align-middle">
              <div
                v-for="(commissionData, subindex) of settlement.commissions"
                :key="'commission-data-' + index + '-' + subindex">
                <small>
                  {{ commissionData.order.order_name }}
                </small>
              </div>
            </td>
            <td class="align-middle">
              <div
                v-for="(settlementData, subindex) of settlement.commissions"
                :key="'settlement-data-' + index + '-' + subindex">
                <small>
                  {{ settlementData.settlement.number }}
                </small>
              </div>
            </td>
            <td
              class="align-middle"
              style="width: 100px;">
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeSettlement(settlement.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="settlements.length === 0">
            <td
              colspan="6"
              class="text-center">
              {{ $t('agents.settlements.noSettlementsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
         {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import CommonGetters from './../../utils/CommonGetters.js';
import FormUtils from './../../utils/FormUtils.js';
import HasPagination from './../../mixins/HasPagination.vue';
import ListUtils from './../../utils/ListUtils.js';
import Pagination from './../../components/common/Pagination.vue';

export default {
  name: 'agent-settlements',
  mixins: [
    HasPagination
  ],
  props: [
    'agentID'
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedCurrencies;
    }
  },
  data() {
    return {
      settlements: [],
      currencies: [],
      loaded: false,
      loadError: false,
      loadedCurrencies: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
    this.loadAdditionalData();
    this.$bus.$on('reload-agent-settlements-list', this.debouncedLoadFilteredData);
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      ListUtils.loadPaginatedItemsData(this, {
        endpoint: '/agents/settlements/items?page=' + this.currentPage,
        listField: 'settlements',
        params: {
          where: {
            agent_id: this.agentID
          }
        }
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/currencies/items',
        loadedKey: 'loadedCurrencies',
        outputKey: 'currencies',
        errorKey: 'loadError'
      });
    },
    removeSettlement (settlementID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/agents/settlements/delete/',
        id: settlementID,
        successTitle: this.$t('agents.settlements.deleteSuccessTitle'),
        successText: this.$t('agents.settlements.deleteSuccessText'),
        confirmTitle: this.$t('agents.settlements.deleteConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('agents.settlements.deleteErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
          this.$bus.$emit('reload-agent-commissions-list');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    getCurrency (currencyID) {
      return CommonGetters.getCurrencyById(currencyID, this.currencies);
    }
  },
  beforeDestroy () {
    this.$bus.$off('reload-agent-settlements-list', this.debouncedLoadFilteredData);
  }
};
</script>

<style lang="scss" scoped>

</style>
